<template>
  <div class="products-container responsive-p">
    <div class="top-header-wrapper">
      <button @click="back" v-if="!isDesktop">
        <img src="@/assets/icons/primary-back.svg" alt="back">
      </button>
      <p class="title">{{ t('myFavorite.title') }}</p>
    </div>
    <div v-if="favoriteProducts" class="products-wrapper">
      <ProductCard
        v-for="(product, index) in favoriteProducts"
        :key="index"
        :title="product.name"
        :price="numberWithCommas(product.effective_price ?? product.price)"
        :originalPrice="numberWithCommas(product.price)"
        :discountPercent="product.discount_percent"
        :discountActive="!!product.is_discount_active"
        :sold="numberWithCommas(product.sold)"
        :thumbnail="product.thumbnail"
        @click="goToProduct(product)"
      />
    </div>
  </div>
</template>

<script>
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import numberWithCommas from '@/utils/numberWithCommas'
import { useScreenSize } from '@/utils/isDesktop'

import ProductCard from '@/components/ProductCard'
export default {
  name: 'FavoriteProducts',
  components: {
    ProductCard,
  },
  setup() {
    /** context */
    const store = useStore()
    const router = useRouter()
    const { t } = useI18n()
    const { isDesktop } = useScreenSize()

    /** computed */
    const favoriteProducts = computed(() => store.state.products.data.favoriteProducts)
    
    /** method */
    const back = () => router.back()
    const goToProduct = product => router.push(`/product/${product.id}?name=${product.name}&desc=${product.description}&price=${product.price}&image=${product.thumbnail}&b=1`)

    /** mounted */
    onMounted(() => {
      store.dispatch('products/fetchGetFavoriteProducts')
    })

    return {
      t,
      back,
      goToProduct,
      favoriteProducts,
      numberWithCommas,
      isDesktop,
    }
  }
}
</script>

<style lang="scss" scoped>

.products-container {
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  padding-top: 56px;
  height: 100%;
  @media screen and (min-width: 780px) {
    padding: 0;
    height: calc(100% - 74px);
  }
}

.top-header-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-bottom: 1px solid #D6E2EF;
  background-color: var(--white-color);
  position: sticky;
  top: 0;
  z-index: 10;
  flex-shrink: 0;
  @media screen and (min-width: 780px) {
    position: relative;
    border-bottom: 0;
  }
  > button {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-weight: bold;
    font-size: 20px;
    color: var(--secondary-color);
    outline: none;
    background-color: transparent;
    border: 0;
    padding: 8px;
  }
}

.products-wrapper {
  padding: 16px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  margin-bottom: 24px;
  @media screen and (min-width: 780px) {
    grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
  }
}
</style>
